import StringValueDTO from './stringValueDTO';

export default class StringValueMergeDTO {
  sourceStringValues: StringValueDTO[];

  targetStringValue: StringValueDTO;

  constructor() {
    this.sourceStringValues = [];
    this.targetStringValue = new StringValueDTO();
  }
}
